import { Fragment } from "react";
import type { GigListItemResponse } from "../../types/gigTypes";
import { formatRoundedGigCompensation } from "../../utils/GigCompensationUtils";
import { formatGigCrewSummary } from "../../utils/GigCrewUtils";
import { formatGigListLocation } from "../../utils/LocationUtils";
import GigDetailGrid, { type RequestFeedback } from "./GigDetailGrid";

type TableRowProps = {
  gig: GigListItemResponse;
  currentUserId?: string | null;
  currentUserZip?: string | null;
  expanded: boolean;
  columnCount: number;
  canRequestAsTeen: boolean;
  isRequesting: boolean;
  hasRequested: boolean;
  feedback: RequestFeedback | null;
  onToggle: (gigId: string) => void;
  onRequestGig: (gig: GigListItemResponse) => void;
};

const TableRow = ({
  gig,
  currentUserId,
  currentUserZip,
  expanded,
  columnCount,
  canRequestAsTeen,
  isRequesting,
  hasRequested,
  feedback,
  onToggle,
  onRequestGig,
}: TableRowProps) => {
  const isOwnGig = Boolean(currentUserId && gig.posterUserId === currentUserId);
  const compensationLabel = formatRoundedGigCompensation(gig.paymentAmountCents, gig.volunteer);
  const crewSummary = formatGigCrewSummary(gig);

  return (
    <Fragment>
      <tr className="cursor-pointer hover:bg-myteengig-background" onClick={() => onToggle(gig.id)}>
        <td className="px-4 py-3 text-center text-sm font-medium text-myteengig-text-primary">
          <span>{gig.title}</span>
          {gig.communityServiceHoursEligible ? <span className="ml-2 text-xs font-semibold text-myteengig-primary">Service hours</span> : null}
        </td>
        <td className="px-4 py-3 text-center text-sm text-myteengig-text-primary">{gig.category}</td>
        <td className="px-4 py-3 text-center text-sm text-myteengig-text-primary">{formatGigListLocation(gig, currentUserZip)}</td>
        <td className="px-4 py-3 text-center text-sm text-myteengig-text-primary">
          <span className="block font-medium">{compensationLabel}</span>
          <span className="mt-1 block text-xs text-myteengig-text-muted">{crewSummary}</span>
        </td>
      </tr>
      {expanded ? (
        <tr>
          <td className="px-4 py-3" colSpan={columnCount}>
            <GigDetailGrid
              gig={gig}
              canRequestAsTeen={canRequestAsTeen}
              isOwnGig={isOwnGig}
              isRequesting={isRequesting}
              hasRequested={hasRequested}
              feedback={feedback}
              onRequestGig={() => onRequestGig(gig)}
            />
          </td>
        </tr>
      ) : null}
    </Fragment>
  );
};

export default TableRow;
